export const ChartColors = {
  blue: '#51A2FF',
  blueBright: '#3B82F6',
  cyan: '#00D3F2',
  orange: '#FF8904',
  amber: '#F59E0B',
  bronze: '#B45309',
  yellow: '#F0B100',
  red: '#FF6467',
  redBright: '#FB2C36',
  green: '#10B981',
  greenBright: '#00BC7D',
  gray: '#94A3B8',
  dark: '#1F2937',
  purple: '#8B5CF6',
  purpleLight: '#C27AFF',
  indigo: '#7C86FF'
} as const

export const SemanticColors = {
  primary: ChartColors.blue,
  secondary: ChartColors.amber,
  tertiary: ChartColors.green,
  danger: ChartColors.red,
  warning: ChartColors.orange,
  info: ChartColors.cyan,
  neutral: ChartColors.gray
} as const

export const MRRChartColors = {
  churn: ChartColors.red,
  existing: ChartColors.blue,
  new: ChartColors.cyan,
  totalTrend: ChartColors.dark
} as const

export const CashFlowChartColors = {
  refunds: ChartColors.red,
  tshirtCosts: ChartColors.amber,
  fees: ChartColors.gray,
  monthlySubs: ChartColors.blue,
  yearlySubs: ChartColors.cyan
} as const

export const EngagementChartColors = {
  primary: ChartColors.blueBright,
  secondary: ChartColors.amber,
  tertiary: ChartColors.green,
  quaternary: ChartColors.purple
} as const

export const EventsChartColors = {
  buyNowClicks: ChartColors.blue,
  presaleCodes: ChartColors.yellow,
  meetAndGreet: ChartColors.greenBright,
  vip: ChartColors.purpleLight,
  rsvp: ChartColors.indigo
} as const

export const CommunityChartColors = {
  posts: ChartColors.blueBright,
  views: ChartColors.amber,
  comments: ChartColors.purple,
  upvotes: ChartColors.green
} as const

export const ChartStyleColors = {
  labelColor: '#6B7280',
  gridColor: '#E5E7EB',
  gridColorDark: '#D1D5DC',
  crosshairColor: '#F3F4F6',
  tooltipBorder: '#e5e7eb',
  tooltipBackground: '#f9fafb'
} as const
